import {
  addEventProcessor,
  getActiveSpan,
  getClient,
  init,
  metrics as sentryMetrics,
  setContext as setSentryContext,
  setTag as setSentryTag,
  setUser,
  startInactiveSpan,
  startSpan,
  type BrowserOptions,
} from '@sentry/react';
import { addBreadcrumb, warn, error, httpError, log, setTag, setContext } from './sentry-logger';

const sentryInstance = {
  addEventProcessor,
  getActiveSpan,
  setContext: setSentryContext,
  setTag: setSentryTag,
  setUser,
  startInactiveSpan,
  startSpan,
};

export const sentry: {
  instance: typeof sentryInstance;
  init: (config: BrowserOptions) => ReturnType<typeof init>;
  getClient: typeof getClient;
  metrics: typeof sentryMetrics;
  log: typeof log;
  warn: typeof warn;
  error: typeof error;
  httpError: typeof httpError;
  addBreadcrumb: typeof addBreadcrumb;
  setTag: typeof setTag;
  setContext: typeof setContext;
} = {
  instance: sentryInstance,
  init: (config: BrowserOptions) => init(config),
  getClient,
  metrics: sentryMetrics,
  log,
  warn,
  error,
  httpError,
  addBreadcrumb,
  setTag,
  setContext,
};

// expose sentry as global so it can be accessed in index.html
(globalThis as any).sentry = sentry;
